module.exports = __webpack_public_path__ + "img/undraw_folder.33498cfa.svg";